module.exports = __webpack_public_path__ + "static/img/school-2.e9c32d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-2.png
// module id = hyxB
// module chunks = 0